import { ref, computed } from 'vue';
import { defineStore, storeToRefs } from 'pinia';
import usePageDataStore from '~/stores/usePageData';
import { getMemberProduct } from '~/utils/product';
import { useStickifiedContextData } from '~/modules/sticky-product-traits/composables/useStickifiedContextData';

const CONSOLIDATED_MEMBER_STORE = 'consolidatedMemberStore';

/**
 * @description Store Factory for Consolidated Member Store.
 * Generates a unique store instance if an ID is provided, allowing for multiple instances (e.g. main product vs sticky ATB).
 */
const useConsolidatedMemberStore = () => {
  const storeName = useStickifiedContextData().getStickifiedContextName<string>(CONSOLIDATED_MEMBER_STORE);

  return defineStore(storeName, () => {
    const { pageData } = storeToRefs(usePageDataStore());
    const selectedMember = ref(0);

    const groupedFlags = computed(() => pageData.value?.flags);
    const product = computed(() => pageData.value?.product);

    const memberFlags = computed(() => groupedFlags.value?.groupByProducts?.[selectedMember.value]);

    const flags = computed(() => memberFlags.value?.productFlags);
    const featureEligible = computed(() => memberFlags.value?.featureEligibilityFlags);
    const memberProduct = computed(() => {
      const rootProduct = product.value?.product;
      return rootProduct ? getMemberProduct(rootProduct, String(selectedMember.value)) : undefined;
    });

    return {
      selectedMember,
      memberFlags: flags,
      memberFeatureEligible: featureEligible,
      memberProduct,
    };
  })();
};

export default useConsolidatedMemberStore;
